import dayjs from 'dayjs';
import { policyCancellationMethodReceived } from '../policyCancellation/const/policyCancellationMethodReceived';
import { policyCancellationDelayReasons } from '../policyCancellation/const/policyCancellationDelayReasons';
import { policyCancellationReasons } from '../policyCancellation/const/policyCancellationReasons';
import { policyCancellationRefundEligibility } from '../policyCancellation/const/policyCancellationRefundEligibility';

const OPTIONS_BY_FIELD = {
  methodReceived: policyCancellationMethodReceived,
  delayReason: policyCancellationDelayReasons,
  cancellationReason: policyCancellationReasons,
  refundEligibility: policyCancellationRefundEligibility,
};

const formatValue = (field, value, t) => {
  if (value === null || value === undefined || value === '') {
    return '-';
  }
  if (field === 'refundAmount') {
    return `$${value}`;
  }
  if (field === 'cancellationRequestDate') {
    return dayjs(value).format('DD-MM-YYYY');
  }
  const option = OPTIONS_BY_FIELD[field]?.find((item) => item.value === value);
  return option ? t(option.label) : value;
};

// Renders the audit entry of an approved or direct cancellation (reviewer changes, final refund, notes).
export const formatCancellationAuditDescription = (audit, t) => {
  const lines = [`Policy Id: ${audit.policyId}`];
  if (audit.changes?.length) {
    lines.push(
      'Modified:',
      ...audit.changes.map(
        ({ field, oldValue, newValue }) =>
          ` ${t(
            `POLICY_DETAILS.AUDIT_HISTORY.MODIFIED_FIELDS.${field}`,
          )} - ${formatValue(field, oldValue, t)} -> ${formatValue(
            field,
            newValue,
            t,
          )}`,
      ),
    );
  }
  if (audit.withoutChanges) {
    lines.push(t('POLICY_DETAILS.AUDIT_HISTORY.approvedWithoutChanges'));
  }
  lines.push(
    `${t('POLICY_DETAILS.AUDIT_HISTORY.finalRefundAmount')}: ${formatValue(
      'refundAmount',
      audit.refundAmount,
      t,
    )}`,
  );
  if (audit.notes) {
    lines.push(`${t('POLICY_DETAILS.AUDIT_HISTORY.notes')}: ${audit.notes}`);
  }
  return lines.join('\n');
};
